import usePreventPaste from "./usePreventPaste";
export { usePreventPaste };
